export default __webpack_public_path__ + "static/media/map-pin.81f80595.svg";